import { saveAs } from 'file-saver';
import { APIClient } from "../helpers/api_helper";
const api = new APIClient();

export const getCredit = () => {
  return api.get('/v1/esims/credit', null)
};

export const getTransactions = () => {
  return api.get('/v1/esims/transactions', null)
};

export const downloadTransactions = (startDate?: string, endDate?: string) => {
  let url = '/v1/esims/download-transactions';
  
  // Add date filters if provided
  if (startDate || endDate) {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    url += '?' + params.toString();
  }
  
  // Use the API client to get the JSON response
  return api.get(url, null)
    .then(response => {
      if (!response || !response.data) {
        throw new Error('Invalid response format');
      }
      
      // Convert base64 string to blob
      const byteCharacters = atob(response.data);
      const byteArrays = [];
      
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        // @ts-ignore
        byteArrays.push(byteArray);
      }
      
      const blob = new Blob(byteArrays, { type: response.mimeType });
      
      // Trigger download with the provided filename
      saveAs(blob, response.filename);
      
      return { success: true };
    })
    .catch(error => {
      console.error('Download failed:', error);
      throw error;
    });
};
